export default __webpack_public_path__ + "static/favicon-08215fedabdb6ccec391cad62849ddbb.png";